import { Box, Alert } from "@mui/material"
import { ReactElement } from "react"

import InstallerBannerContent from "./InstallerBannerContent"
import { useGetUserData } from "../../hooks/useGetUserData"

const SearchPlaceHolder = (): ReactElement | null => {
    const { isSignedIn, isInstaller } = useGetUserData()

    if (!isSignedIn) {
        return null
    }

    return (
        <Box
            flexGrow={1}
            sx={{
                display: "block",
            }}
            justifyItems="center"
        >
            <Alert
                severity="info"
                sx={{
                    width: "80%",
                    marginLeft: 4,
                }}
            >
                {isInstaller ? <InstallerBannerContent /> : null}
            </Alert>
        </Box>
    )
}

export default SearchPlaceHolder
